export default [
  {
    name: "Billing",
    path: "/billing/rules",
    component: () => import("@/modules/billing/pages/Billing"),
    meta: {
      ability: [
        {
          resource: "pricing-level-group",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Details",
    path: "/billing/view/:id",
    component: () => import("@/modules/billing/pages/BillingDetails"),
    meta: {
      ability: [
        {
          resource: "pricing-level-group/:id",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Add Billing",
    path: "/billing/add",
    component: () => import("@/modules/billing/pages/BillingCreate"),
    meta: {
      ability: [
        {
          resource: "pricing-level-group",
          actions: ["create"],
        },
      ],
    },
  },
  {
    name: "Billing",
    path: "/billing/report",
    component: () => import("@/modules/billing/pages/Report"),
    meta: {
      ability: [
        {
          resource: "billing-report",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Details",
    path: "/billing/report/:date/:id",
    component: () => import("@/modules/billing/pages/ReportDetails"),
    meta: {
      ability: [
        {
          resource: "billing-report",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Revenue Report",
    path: "/billing/revenue-report",
    component: () => import("@/modules/billing/revenueReport/pages/Report"),
    meta: {
      ability: [
        {
          resource: "revenue-report/monthly",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Product Revenue Report",
    path: "/billing/revenue-product-report",
    component: () => import("@/modules/billing/revenueReport/pages/ProductReport"),
    meta: {
      ability: [
        {
          resource: "revenue-report/product",
          actions: ["read"],
        },
      ],
    },
  },
];
